<template>
  <notification-list />
</template>

<script>
import NotificationList from "@/components/NotificationList";

export default {
  name: "AdminNotifications",
  components: {NotificationList}
}
</script>

<style scoped>

</style>
